import { gql } from "@apollo/client";

/**
 * Mutation pour transmettre les événements Meta au CAPI (Conversions API).
 * Utilise EventDataInput (schéma backend) - event_id identique au Pixel pour le dédoublonnage Meta.
 */
export const SEND_META_CONVERSION_EVENT = gql`
  mutation SendMetaConversionEvent($eventData: EventDataInput!) {
    sendMetaConversionEvent(eventData: $eventData)
  }
`;
